
import CustomCursorMixin from '@/mixins/carrouselCustomCursor.js';
import PhotoSwipeMixin from '@/mixins/photoSwipe';

export default {
  name: "SwiperCarrousel",
  mixins: [CustomCursorMixin, PhotoSwipeMixin],
  props: {
    slides: Array,
    photoSwipeActive: {
      type: Boolean,
      default: false,
      required: false
    },
    fixedHeight: {
      type: Boolean,
      default: false,
      required: false
    },
  },
  data() {
    return {
      isSwiper: true,
      swiper: null,
      galleryID: "#swiper-gallery",
      swiperOptions: {
        slidesPerView: 'auto',
        spaceBetween: 10,
        slidesPerGroup: 1,
        slidesOffsetBefore: 16,
        slidesOffsetAfter: 14,
        loop: false,
        loopFillGroupWithBlank: false,
        // centeredSlides: true,
        // pagination: false,
        // navigation: {
        //   nextEl: '.swiper-button-next',
        //   prevEl: '.swiper-button-prev'
        // },
        // Responsive breakpoints
        breakpoints: {
          // when window width is >= 320px
          320: {
            spaceBetween: 10,
            slidesPerView: 1.15,
            draggable: false,
          },
          // when window width is >= 768px
          768: {
            spaceBetween: 20,
            slidesPerView: 'auto',
            slidesOffsetBefore: 40,
            slidesOffsetAfter: 20,
            // slidesPerGroup: 1,
          },
          1220: {
            slidesPerView: 'auto',
            spaceBetween: 20,
            slidesOffsetBefore: 40,
            slidesOffsetAfter: 40,
          },
          1280: {
            slidesPerView: 'auto',
            spaceBetween: 20,
            slidesOffsetBefore: 40,
            slidesOffsetAfter: 20,
          },
          1500: {
            slidesPerView: 'auto',
            spaceBetween: 20,
            slidesOffsetBefore: 40,
            slidesOffsetAfter: 40,
          }
        }
      }
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.initializeSwiper();
    });
  },
  methods: {
    initializeSwiper() {
      this.swiper = new this.$swiper(this.$refs.swiperElement, {
        loop: true,
        // modules: [this.$swiperModules.Navigation],
        ...this.swiperOptions
      });
    },
    triggerSlideCarrousel(directionLeft) {
      if (directionLeft) {
        this.swiper.slideNext();
      } else {
        this.swiper.slidePrev();
      }
    },
  }
};
